module.exports = __webpack_public_path__ + "static/media/plus.a4d496b8.svg";